import { Common } from '@stockbit/ui';
import { AVATAR_URL } from 'constants/api';
import { LabelVerifiedAccount } from 'global/Labels';
import { VerifiedStatus } from 'lib/api/verifiedBadge';
import { handleErrorAvatar } from 'utils/general';
import Image from 'global/Image';
import { DISCOVER_PEOPLE_STATE } from '../constants';

const { Flex, Avatar } = Common;
interface UserSearchItemTypes {
  index: number;
  dataUserSearch: {
    id: string;
    img: string;
    name: string;
    desc: string;
    is_following: boolean;
    official: number;
    url: string;
    type: string;
    other: string;
    total_followers: number;
    is_verified: boolean;
    verified_status?: VerifiedStatus;
  };
  onFollow: (
    index: number,
    followed: boolean,
    userid: number | string,
    type: string,
  ) => void;
}

// UserSearchItem Compoonent
// web legacy
// app\components\general\dumb\OnboardingPage\OnboardingStepThree\UserSearchItem.js
function UserSearchItem({
  index,
  dataUserSearch,
  onFollow,
}: UserSearchItemTypes) {
  const {
    id: userId,
    img,
    name,
    is_following: followed,
    desc,
    is_verified: isVerified,
  } = dataUserSearch;

  const followedLabel = followed ? 'Following' : 'Follow';
  const followedClass = followed ? 'following' : 'follow';

  /**
   * onFollowUser
   * call onFollow
   * with userId, user status followed and username
   * @param {*} e event
   */
  const onFollowUser = (e) => {
    e.preventDefault();

    onFollow(index, followed, userId, DISCOVER_PEOPLE_STATE.SEARCH);
  };

  return (
    <div key={`trending_user_${userId}`} className="boarding-list">
      <div className="boarding-list-item">
        <div className="stream-avatar" data-username={name}>
          <Avatar size="medium">
            <Image
              alt={img}
              src={`${AVATAR_URL}/${img}`}
              style={{
                width: 40,
                height: 40,
              }}
              onError={(e) => handleErrorAvatar(e, name)}
            />
          </Avatar>
        </div>

        <div className="follow-bio">
          <div className="follow-bio-in">
            <Flex align="center" direction="row">
              <a>{name}</a>
              <LabelVerifiedAccount
                deprecatedVerifiedStatus={isVerified}
                verifiedStatus={dataUserSearch?.verified_status}
              />
            </Flex>
            <div>{desc}</div>
          </div>
        </div>

        <div
          role="button"
          tabIndex={0}
          className={`button follow-${followedClass}`}
          onClick={onFollowUser}
          onKeyUp={onFollowUser}
        >
          {followedLabel}
        </div>
      </div>
    </div>
  );
}

export default UserSearchItem;
